"use strict";

exports.__esModule = true;
exports.consumer = exports.Provider = void 0;

var _react = _interopRequireDefault(require("react"));

var _createReactContext = _interopRequireDefault(require("create-react-context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var context = (0, _createReactContext.default)(); // eslint-disable-next-line

var Provider = context.Provider;
exports.Provider = Provider;

var consumer = function consumer(Origin) {
  return function (props) {
    return _react.default.createElement(context.Consumer, null, function (value) {
      return _react.default.createElement(Origin, _extends({}, props, value));
    });
  };
};

exports.consumer = consumer;